import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';

export const useLogClickTooltip = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsBasic } = useGoodsBasic();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_TOOLTIP',
      analytics: {
        TYPE: goodsBasic?.delivery_type_info.delivery_type,
        SALES_METHOD: goodsBasic?.sales_method_info?.sales_method,
      },
    });
  }, [
    goodsBasic?.delivery_type_info.delivery_type,
    goodsBasic?.sales_method_info?.sales_method,
    logGoodsAnalytics,
  ]);
};
